module.exports = __webpack_public_path__ + "static/media/shape-ii.66adb278.svg";